import type { FormEvent } from 'react';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import ReleaseHelp from './ReleaseHelp';

type ProjectGroupReleaseTitleInputProps = {
  title: string;
  label?: string;
  onChangeTitle(event: FormEvent<FormControl>): void;
}

const ProjectGroupReleaseTitleInput = ({ title, label = 'Release', onChangeTitle }: ProjectGroupReleaseTitleInputProps) => {
  return (
    <FormGroup>
      <ControlLabel className="text-label">
        {label} <ReleaseHelp />
      </ControlLabel>
      <FormControl
        key="release-input"
        type="text"
        value={title}
        onChange={onChangeTitle}
        placeholder="1.0"
      />
    </FormGroup>
  );
};

export default ProjectGroupReleaseTitleInput;
